import classnames from 'classnames';
import { FunctionComponent, PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';

const FormContainer: FunctionComponent<PropsWithChildren<{}>> = props => {
  const { children } = props;

  const location = useLocation();
  const isPolicyRoute = location.pathname.includes('content-policy-reporting');

  const { t } = useTranslation(isPolicyRoute ? 'content_policy_reporting' : 'infringement_claim_form');

  return (
    <ErrorBoundary>
      <div className={classnames('container')}>
        <Helmet>
          <title>{t('main_title')}</title>
          <meta name="robots" content="index, follow" />
        </Helmet>
        {children}
      </div>
    </ErrorBoundary>
  );
};

export default FormContainer;
